import { render, staticRenderFns } from "./NotAuthorized.vue?vue&type=template&id=9539e002&"
import script from "./NotAuthorized.vue?vue&type=script&lang=js&"
export * from "./NotAuthorized.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QForm,QCardSection,QScrollArea,QSeparator,QOptionGroup,QCardActions} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QForm,QCardSection,QScrollArea,QSeparator,QOptionGroup,QCardActions})
